export default __webpack_public_path__ + "static/media/480_business03-fr-mobile.e78ac736.png";